import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    incomingMessageData: {},
    activeUserData: {},
    messageCategoryData: {},
    botKnowledgeData: {},
    botPerformanceData: {},
    totalUserData: {},
    ruleBaseData: {},
    flowStatData: {},
    activeUserDataHeatmap: {},
    trendingTopicsData: {},
    generativeAIUsageData: {},
    generativeAIUsagePromptLogData: {
      data: [],
      cursor: {
        cursorId: '',
        cursorSort: 0,
      },
      last: false,
    },
  },
  getters: {
    incomingMessageData: (state) => state.incomingMessageData,
    incomingMessageStat: (state) => {
      const data = state.incomingMessageData;
      if (data && data.incomingMessageStat) {
        return data.incomingMessageStat;
      }
      return {};
    },
    conversationStat: (state) => {
      const data = state.incomingMessageData;
      if (data && data.conversationStat) {
        return data.conversationStat;
      }
      return {};
    },
    incomingMessageHistory: (state) => {
      const data = state.incomingMessageData;
      if (data && data.incomingMessageHistory) {
        return data.incomingMessageHistory;
      }
      return [];
    },
    activeUserData: (state) => state.activeUserData,
    activeUserStat: (state) => {
      const data = state.activeUserData;
      if (data && data.activeUserStat) {
        return data.activeUserStat;
      }
      return {};
    },
    activeUserHistory: (state) => {
      const data = state.activeUserData;
      if (data && data.activeUserHistory) {
        return data.activeUserHistory;
      }
      return [];
    },
    activeUserDataHeatmap: (state) => {
      const data = state.activeUserDataHeatmap;
      if (data && data.activeTime) {
        return data;
      }
      return [];
    },
    messageCategoryData: (state) => state.messageCategoryData,
    messageCategoryStat: (state) => {
      const data = state.messageCategoryData;
      if (data && data.modelList) {
        return data.modelList;
      }
      return [];
    },
    botKnowledgeData: (state) => state.botKnowledgeData,
    botPerformanceData: (state) => state.botPerformanceData,
    totalUserData: (state) => state.totalUserData,
    ruleBaseData: (state) => state.ruleBaseData,
    ruleBaseStat: (state) => {
      const data = state.ruleBaseData;
      if (data && data.ruleSetList) {
        return data.ruleSetList;
      }
      return [];
    },
    flowStatData: (state) => state.flowStatData,
    flowStat: (state) => {
      const data = state.flowStatData;
      if (data && data.modelList) {
        return data.modelList;
      }
      return [];
    },
    trendingTopicsData: (state) => state.trendingTopicsData,
    generativeAIUsageData: (state) => state.generativeAIUsageData,
    generativeAIUsagePromptLogData: (state) => state.generativeAIUsagePromptLogData,
  },
  actions: {
    loadIncomingMessageData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getIncomingMessageHistory(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setIncomingMessageData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadActiveUserData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getActiveUserHistory(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setActiveUserData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadActiveUserDataHeatmap(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getActiveUser(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setActiveUserDataHeatmap', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadExportData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getExportActiveUser(criteria)
          .then((response) => {
            // const { data } = response.data;
            // context.commit('setExportData', data);
            // console.log(response.data);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            const elem = document.getElementById('download-area');
            link.href = url;
            link.setAttribute('download', 'active-user-and-active-time.xlsx');
            elem.innerHTML = '';
            elem.appendChild(link);
            link.click();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadMessageCategoryData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getMessageCategoryStat(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setMessageCategoryData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadFlowStatData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getFlowStat(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setFlowStatData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadRuleBaseMatchData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice.getRuleBaseMatchStat(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setRuleBaseMatchStatData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadBotKnowledge(context) {
      return new Promise((resolve, reject) => {
        alice
          .getBotKnowledge()
          .then((response) => {
            const { data } = response.data;
            context.commit('setBotKnowledgeData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadBotPerformance(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getBotPerformance(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setBotPerformanceData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTotalUserData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getTotalUser(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setTotalUserData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadTrendingTopicsData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getTrendingTopics(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setTrendingTopicsData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadGenerativeAIUsageData(context, params) {
      const { criteria } = params;
      return new Promise((resolve, reject) => {
        alice
          .getGenerativeAIUsageHistory(criteria)
          .then((response) => {
            const { data } = response.data;
            context.commit('setGenerativeAIUsageData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadGenerativeAIUsagePromptlogData(context, params) {
      const {
        criteria,
        sortField,
        cursorSort,
        cursorId,
        size
      } = params;
      const requestBody = {
        criteria,
        sortField,
        size
      };
      if (
        cursorSort
        && typeof cursorSort === 'number'
        && cursorId
        && typeof cursorId === 'string'
      ) {
        requestBody.cursor = {
          cursorId,
          cursorSort: `${cursorSort}`,
        };
      }
      return new Promise((resolve, reject) => {
        alice
          .getGenerativeAIUsagePromptLog(requestBody)
          .then((response) => {
            const { data } = response.data;
            const formatResData = {
              data: context.state.generativeAIUsagePromptLogData.data.concat(data.data),
              cursor: data.cursor,
              last: data.last,
            };
            context.commit('setGenerativeAIUsagePromptLogData', formatResData);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    resetGenerativeAIUsagePromptlogData(context) {
      const initData = {
        data: [],
        cursor: {
          cursorId: '',
          cursorSort: 0,
        },
        last: false,
      };
      context.commit('setGenerativeAIUsagePromptLogData', initData);
    }
  },
  mutations: {
    setIncomingMessageData(state, data) {
      Vue.set(state, 'incomingMessageData', data);
    },
    setActiveUserData(state, data) {
      Vue.set(state, 'activeUserData', data);
    },
    setActiveUserDataHeatmap(state, data) {
      Vue.set(state, 'activeUserDataHeatmap', data);
    },
    setExportData(state, data) {
      Vue.set(state, 'activeUserDataHeatmap', data);
    },
    setMessageCategoryData(state, data) {
      Vue.set(state, 'messageCategoryData', data);
    },
    setBotKnowledgeData(state, data) {
      Vue.set(state, 'botKnowledgeData', data);
    },
    setBotPerformanceData(state, data) {
      Vue.set(state, 'botPerformanceData', data);
    },
    setTotalUserData(state, data) {
      Vue.set(state, 'totalUserData', data);
    },
    setRuleBaseMatchStatData(state, data) {
      Vue.set(state, 'ruleBaseData', data);
    },
    setFlowStatData(state, data) {
      Vue.set(state, 'flowStatData', data);
    },
    setTrendingTopicsData(state, data) {
      Vue.set(state, 'trendingTopicsData', data);
    },
    setGenerativeAIUsageData(state, data) {
      Vue.set(state, 'generativeAIUsageData', data);
    },
    setGenerativeAIUsagePromptLogData(state, data) {
      Vue.set(state, 'generativeAIUsagePromptLogData', data);
    },
  },
};
